import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  constructor() {}

  getNestedObject(nestedObj: any, pathArr: any) {
    return pathArr.reduce((obj: any, key: any) => (obj && obj[key] !== 'undefined' ? obj[key] : undefined), nestedObj);
  }

  getStringValue(object: any, propertyName: string) {
    const result = this.getNestedObject(object, [propertyName]);
    return result || '';
  }
  getEntityListName(name: string) {
    const newName = name.endsWith('s') ? name : `${name}s`;
    return newName.toLowerCase();
  }
  getValidUrl(prefixUid: string, uid: string): string {
    let fullUrl = '';
    if (prefixUid) {
      fullUrl += prefixUid;
    }
    if (uid) {
      let uidUrl = uid;
      if (!uidUrl.startsWith('/')) {
        uidUrl = `/${uid}`;
      }
      fullUrl += uidUrl;
    }
    if (fullUrl.charAt(0) === '/') {
      fullUrl = fullUrl.slice(1);
    }
    return fullUrl;
  }

  parseUrlPathInSegments(fullUrl: string): Array<string> {
    const result = fullUrl
      .split('/')
      .filter((segment) => segment)
      .map((segment) => {
        let path = segment;
        const paramPos = path.indexOf(';');
        if (paramPos > -1) {
          path = path.substring(0, paramPos);
        }
        const outletPos = path.indexOf(':');
        if (outletPos > -1) {
          path = path.substring(outletPos + 1, path.length - 1);
        }
        return path;
      });
    return result;
  }

  getMediaType(mediaURL: string): string {
    const imageFileExtensionWhitelist: string[] = ['gif', 'jpg', 'jpeg', 'png', 'svg', 'ico'];
    const mediaFileExtension = mediaURL?.substring(mediaURL?.lastIndexOf('.') + 1);

    return imageFileExtensionWhitelist.includes(mediaFileExtension) ? 'image' : 'video';
  }

  removeDuplicates(array: any[]) {
    return [...new Set(array)];
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, (txt) => {
      const acronymsRequiringUppercase: string[] = ['tv', 'sim', '4g', '5g'];

      return acronymsRequiringUppercase.includes(txt)
        ? txt.toUpperCase()
        : txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
}
